<template>
  <div class="import-temp">
    <el-upload
      drag
      ref="upload"
      :before-upload="beforeUploadFile"
      accept=".xls,.xlsx"
      :headers="uploadHeader"
      :action="importEntAppeal"
      :file-list="fileList"
      :on-success="uploadSuc"
      :on-error="uploadErr"
      :on-change="changeData"
      :limit="1"
      :on-remove="removeData"
      :auto-upload="false"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <div class="el-upload__tip" slot="tip">
      <div>说明</div>
      <div>
        只支持上传Excel格式的文件。企业数据更新方式为增量更新，自动过滤文件中重复的企业
      </div>
      <div>如何填写规范的表格？</div>
      <Debounce :time="3000" :isDebounce="3">
        <button
          type="button"
          class="el-button el-button--text"
          @click="downLoadImportAppealTemplate"
        >
          <span>点击此处下载模版</span>
        </button>
      </Debounce>
    </div>
  </div>
</template>

<script>
import { getToken } from '@utils'
import {
  downLoadImportAppealTemplate,
  importEntAppeal
} from '@api/dataMaintenance/dataMaintenance'
export default {
  name: 'ImportTemp',
  data() {
    return {
      data: '1',
      importEntAppeal,
      downLoadImportAppealTemplate,
      fileList: [],
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      }
    }
  },
  methods: {
    // 上传成功
    uploadSuc(response) {
      this.$emit('uploadOver', { type: 1, data: response })
    },
    // 上传失败
    uploadErr(errmsg) {
      this.$emit('uploadOver', { type: 0, data: errmsg })
    },
    changeData(file, fileList) {
      this.fileList = fileList
    },
    removeData(file, fileList) {
      this.fileList = fileList
    },
    beforeUploadFile(file) {
      if (
        [
          'application/vnd.ms-excel',
          'application/x-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ].indexOf(file.type) == -1
      ) {
        this.fileList = []
        this.$emit('uploadFail', false) // 提交按钮能够重新可点击
        this.$message.error('请上传正确的文件格式')
        return false
      }
    },
    submit() {
      if (this.fileList.length == 0) {
        this.$message({
          message: '请选择文件后进行提交操作',
          type: 'warning'
        })
        this.$emit('uploadFail', false)
        return
      }
      this.$refs.upload.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.import-temp {
  /deep/.el-upload {
    display: block;
  }
  /deep/.el-upload-dragger {
    width: 100%;
  }
  .el-upload__tip {
    div {
      margin: 5px 0;
      line-height: 20px;
      font-size: 14px;
    }
    div:nth-child(2n + 1) {
      color: black;
    }
    div:nth-child(3) {
      margin-bottom: 0;
    }
  }
}
</style>
